(() => {
  if (!document.documentElement.classList.contains('jk-whatsapp-visit')) return;

  const storeHosts = new Set([location.hostname, 'getkekka.com', 'www.getkekka.com', 'cewejm-zc.myshopify.com']);
  const productLinks = JSON.parse(document.getElementById('jk-whatsapp-product-links')?.textContent || '{}');
  productLinks['bare-stik-women'] = productLinks['bare-stik'];
  const rewritten = new WeakMap();
  function rewrite(link) {
    const href = link.getAttribute('href');
    if (!href) return;
    if (rewritten.get(link) === href) return;
    let url;
    try { url = new URL(href, location.href); } catch (_) { return; }
    if (!['https:', 'http:'].includes(url.protocol) || !storeHosts.has(url.hostname)) return;
    const product = url.pathname.match(/\/products\/([^/]+)\/?$/);
    if (product && productLinks[product[1]]) {
      const destination = new URL(productLinks[product[1]], location.href);
      url.searchParams.delete('variant'); // Original variant IDs do not belong to duplicate products.
      url.searchParams.forEach((value, key) => {
        if (!destination.searchParams.has(key)) destination.searchParams.set(key, value);
      });
      if (!destination.hash) destination.hash = url.hash;
      const next = storeHosts.has(destination.hostname)
        ? destination.pathname + destination.search + destination.hash : destination.href;
      rewritten.set(link, next);
      if (next !== href) link.setAttribute('href', next);
      return;
    }
    if (!/\/collections\/shop-all(?:\/|$)/.test(url.pathname)) return;
    url.pathname = url.pathname.replace(/\/collections\/shop-all(?=\/|$)/, '/collections/shop-all-whatsapp');
    // Relative URLs preserve the current preview host, locale, filters and tracking.
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function scan(root) {
    if (root.matches?.('a[href]')) rewrite(root);
    root.querySelectorAll?.('a[href]').forEach(rewrite);
  }

  function initialize() {
    scan(document);
    // Homepage Buy buttons normally launch checkout for the original product.
    // In campaign mode take the visitor to the configured duplicate product instead.
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.kekka-mobile-product__buy, .sr-headless-checkout');
      if (!button || !button.closest('.kekka-mobile-product, .desktop-product')) return;
      const original = button.closest('form')?.querySelector('[name="productUrl"]')?.value;
      if (!original) return;
      const link = document.createElement('a');
      link.setAttribute('href', original);
      rewrite(link);
      if (link.getAttribute('href') === original) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(link.href);
    }, true);
    // Covers AJAX cart markup, menu swaps and theme-editor section reloads.
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') rewrite(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
